import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import images from '../../images';
import { auth, provider } from '../../config/firebase';
import './styles.css';

class Login extends Component {
  constructor(props) {
    super(props)

    this.state = {
      redirectToReferrer: false
    }

    this.handleSignIn = this.handleSignIn.bind(this);
  }

  handleSignIn() {
    auth.signInWithPopup(provider).then((result) => {
      this.setState({ redirectToReferrer: true })
    }).catch((error) => {
      console.log(error);
    });
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } }
    const { redirectToReferrer } = this.state

    if (redirectToReferrer) {
      return (
        <Redirect to={from}/>
      )
    }

    return (
      <div className="login">
        <div>
          <img src={images.logo} alt="logo" />
          <h1>Plum Village Admin</h1>
          <Button variant="raised" color="secondary" onClick={this.handleSignIn}>
            <Icon>account_circle</Icon>
            Sign in with Google
          </Button>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/scenes/Login/index.js